const InterviewAccord = ({ answer }) => {
  return (
    <div className="p-3">
      <p className="h5 text-dark animate">{answer}</p>
    </div>
  );
};

export default InterviewAccord;
